// extracted by mini-css-extract-plugin
export default {"menumobileId":"NaveBar_menumobileId__UAUJb","close":"NaveBar_close__jFC2u","navebar":"NaveBar_navebar__nFE8R","menupcId":"NaveBar_menupcId__HsFzt"};